import React from "react";

const TabularEntity = (props) => {
  const tabularEntityContainerStyles = {
    padding: "20px",
  };

  const renderSectionHeader = (header) => {
    const sectionHeaderStyles = {
      fontSize: "13px",
      fontWeight: "bold",
      color: "#AEB0B5",
      textTransform: "uppercase",
    };
    return <h5 style={sectionHeaderStyles}>{header}</h5>;
  };

  const renderFieldRow = (number, label, value) => {
    const fieldRow = {
      display: "flex",
    };

    const numberLabel = {
      flex: "1",
      marginRight: "4rem",
    };

    return (
      <div style={fieldRow}>
        <div style={numberLabel}>{`${number}. ${label}`}</div>
        <div className={"text-bold"}>{value}</div>
      </div>
    );
  };

  const renderTabularData = () => {
    const { ui } = props;
    return (
      <div>
        <h3>{ui.name}</h3>
        {ui.sections.map((section) => {
          return (
            <div>
              {renderSectionHeader(section.name)}
              {section.fields.map((field) => {
                return (
                  <div>
                    {renderFieldRow(
                      field.number,
                      field.label,
                      field.value || "n/a"
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div style={tabularEntityContainerStyles}>
      {renderTabularData()}
      {props.children}
    </div>
  );
};

export default TabularEntity;
